import { ReactComponent as ProfileImage } from '@brand/assets/images/profile.svg';
import { Avatar as MuiAvatar, AvatarProps as MuiAvatarProps } from '@mui/material';
import { Avatar as AvatarType, usePermanentFileLinkLazyQuery } from 'generated/graphql';
import { ReactElement, useEffect, useState } from 'react';

interface AvatarProps extends Omit<MuiAvatarProps, 'src'> {
  avatar: Partial<AvatarType> | undefined | null;
  size?: 'fullSize' | 'thumbnail' | number | null;
  sx?: MuiAvatarProps['sx'];
  children?: ReactElement;
}

const AVATAR_FULLSIZE_SIZE = 96;
const AVATAR_THUMBNAIL_SIZE = 40;

export const Avatar: React.FC<AvatarProps> = ({ avatar, children, size, sx, ...props }) => {
  const [avatarUrl, setAvatarUrl] = useState('');
  const [getDownloadUrl] = usePermanentFileLinkLazyQuery();

  let finalSize;
  if (size === 'fullSize') finalSize = AVATAR_FULLSIZE_SIZE;
  else if (size === 'thumbnail') finalSize = AVATAR_THUMBNAIL_SIZE;
  else finalSize = size ?? AVATAR_THUMBNAIL_SIZE;

  const fileId = finalSize > AVATAR_THUMBNAIL_SIZE ? avatar?.fullSize?.id : avatar?.thumbnail?.id;

  useEffect(() => {
    if (!!fileId) {
      getDownloadUrl({ variables: { fileId } }).then((res) => {
        if (res.data?.permanentFileLink) setAvatarUrl(res.data?.permanentFileLink);
      });
    } else {
      setAvatarUrl('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileId]);

  return (
    <MuiAvatar
      src={avatarUrl}
      sx={[{ height: finalSize, width: finalSize }, ...(Array.isArray(sx) ? sx : [sx])]}
      {...props}
    >
      {children ?? <ProfileImage height={finalSize} width={finalSize} />}
    </MuiAvatar>
  );
};
